import { render, staticRenderFns } from "./switchers.vue?vue&type=template&id=660d081a"
import script from "./switchers.vue?vue&type=script&lang=js"
export * from "./switchers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports